import {
  Box,
  TextInput,
  DatePicker,
  Dropdown,
  SelectInput,
  DropdownOverlay,
  ActionList,
  ActionListItem,
} from '@razorpay/blade/components';
import { PersonalDetailsFormFields } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/types';
import { RegisterGenericType } from 'forms/useRegister';

import { maritalStatusOptions } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/constants';
import { useOptionalFields } from '../hooks/useOptionalFields';

interface CustomFieldsProps {
  register: RegisterGenericType<PersonalDetailsFormFields>;
  formData: Partial<PersonalDetailsFormFields>;
}

export const CustomFields = ({ register, formData }: CustomFieldsProps) => {
  const { optionalFieldsKeys, optionalFields, regularFieldsKeys } = useOptionalFields();

  return (
    <Box display="flex" flexDirection="column" gap="spacing.5">
      {optionalFieldsKeys.includes('personalEmail') && (
        <TextInput
          label="Personal Email"
          placeholder="Enter your personal email"
          {...register('personalEmail')}
        />
      )}

      {optionalFieldsKeys.includes('maritalStatus') && (
        <Dropdown selectionType="single">
          <SelectInput
            label="Marital Status"
            placeholder="Select marital status"
            {...register('maritalStatus', 'select')}
          />
          <DropdownOverlay>
            <ActionList>
              {maritalStatusOptions.map((option) => (
                <ActionListItem
                  key={option.value}
                  title={option.title}
                  value={option.value}
                  isSelected={(formData.maritalStatus as unknown as string[])?.[0] === option.value}
                />
              ))}
            </ActionList>
          </DropdownOverlay>
        </Dropdown>
      )}

      {optionalFieldsKeys.includes('marriageAnniversary') &&
        (formData.maritalStatus as unknown as string[])?.[0] === 'Married' && (
          <DatePicker
            label="Marriage Anniversary"
            selectionType="single"
            {...register('marriageAnniversary', 'date')}
            format="DD/MM/YYYY"
            maxDate={new Date()} //future dates not allowed
          />
        )}

      {regularFieldsKeys.map((key) => {
        const field = optionalFields[key];
        return <TextInput key={field.key} label={field.label} {...register(field.key)} />;
      })}
    </Box>
  );
};
